function HeaderBlock({ data }) {
  const { text, level } = JSON.parse(data);
  const Tag = `h${level}`;
  return <Tag className="text-[20px]  capitalize md:text-2xl font-bold my-4">{text}</Tag>;
}

export default HeaderBlock;
